// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__Rm7ln","header":"ClearentDisclaimer_header__27OBF","inner":"ClearentDisclaimer_inner__cAT3g"};